import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';

const TransactionDetailModal = ({ transaction, bookings, onClose, onViewBooking }) => {
  if (!transaction) return null;

  const status = transaction.payment_status || transaction.status;
  const platformFee = transaction.platform_fee_amount || transaction.platform_fee || 0;
  const vendorPayout = transaction.vendor_payout || ((transaction.amount || 0) - platformFee);

  const getStatusDisplay = () => {
    if (status === 'succeeded') return 'Completed';
    if (status === 'pending') return 'Processing';
    if (status) return status.charAt(0).toUpperCase() + status.slice(1);
    return 'Processing';
  };

  const getStatusClass = () => {
    if (status === 'succeeded') return 'bg-green-100 text-green-800';
    if (status === 'pending') return 'bg-yellow-100 text-yellow-800';
    return 'bg-blue-100 text-blue-800';
  };

  const handleViewBooking = () => {
    const booking = bookings.find(b => b.id === transaction.booking_id);
    if (booking) {
      onClose();
      onViewBooking(booking);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="border-b">
          <div className="flex justify-between items-start">
            <div>
              <CardTitle>Transaction Details</CardTitle>
              <CardDescription>Payment Information</CardDescription>
            </div>
            <Button variant="ghost" size="sm" onClick={onClose}>✕</Button>
          </div>
        </CardHeader>
        <CardContent className="p-6 space-y-4">
          <div className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Transaction ID:</span>
              <span className="font-mono text-xs">{transaction.id}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Type:</span>
              <span className="capitalize">{transaction.type || 'payment'}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Amount:</span>
              <span className="font-semibold">${transaction.amount?.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Platform Fee:</span>
              <span>${platformFee.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Vendor Payout:</span>
              <span className="font-semibold text-green-600">${vendorPayout.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Status:</span>
              <Badge className={getStatusClass()}>
                {getStatusDisplay()}
              </Badge>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Customer:</span>
              <span>{transaction.customer_name || 'N/A'}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Booking ID:</span>
              <button 
                className="font-mono text-xs text-blue-600 hover:underline"
                onClick={handleViewBooking}
              >
                {transaction.booking_id?.slice(0, 12)}... →
              </button>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Date:</span>
              <span>{transaction.created_at ? new Date(transaction.created_at).toLocaleString() : 'N/A'}</span>
            </div>
            {transaction.stripe_payment_intent_id && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Stripe ID:</span>
                <span className="font-mono text-xs">{transaction.stripe_payment_intent_id?.slice(0, 20)}...</span>
              </div>
            )}
          </div>

          <div className="pt-2">
            <Button variant="outline" className="w-full" onClick={onClose}>
              Close
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TransactionDetailModal;
